import React, { useEffect, useState } from 'react';
import { LicenceRequirementSteps as Steps } from '../../../../../services/licence';
import { AuthProfileValidatorLimitsProps as Props } from '../../../../../services/responsible-gaming';
import { translate } from '../../../../../services/translate';
import { stores } from '../../../../../stores';
import AuthProfileValidatorLimits from '../../limits/AuthProfileValidatorLimits';
import { useStore } from '../../../../../hooks/useStore';
import AuthProfileValidatorRequiredFields from '../../required-fields/AuthProfileValidatorRequiredFields';
import { LIMIT_TYPE } from '../../../../../services/responsible-gaming/types';

export default function AuthProfileValidatorLicenceRequirementEstonia(props: Props) {
    const { onAfterSubmit, isModal } = props;
    const [step, setStep] = useState<Steps>(Steps.LOSS_LIMIT);

    const [user] = useStore(stores.user);
    const [askLossLimit] = useStore(stores.responsibleGaming.askLossLimit);

    useEffect(() => {
        if (user?.isProfileReviewRequired) {
            setStep(Steps.REQUIRED_FIELDS);
        }
    }, [user?.isProfileReviewRequired]);

    const modals = {
        [Steps.REQUIRED_FIELDS]: (
            <AuthProfileValidatorRequiredFields isModal={isModal} onAfterSubmit={goToNextStep} onExit={goToNextStep} />
        ),
        [Steps.LOSS_LIMIT]: (
            <AuthProfileValidatorLimits
                {...props}
                key="loss-limit"
                heading={translate('Loss limits', 'ui.account')}
                isOfferOnly={true}
                limitType={LIMIT_TYPE.LOSS}
                onAfterSubmit={goToNextStep}
                snippetKey={'auth.update-est-license-fields'}
            />
        ),
    };

    function goToNextStep() {
        if (step === Steps.LOSS_LIMIT && user?.isProfileReviewRequired) {
            setStep(Steps.REQUIRED_FIELDS);
        } else if (step === Steps.REQUIRED_FIELDS && askLossLimit) {
            setStep(Steps.LOSS_LIMIT);
        } else {
            onAfterSubmit();
        }
    }

    return modals[step];
}
